import { getLeFEOrigin } from '@utils/util';

export const BohriumCourseApply = () => (
    <iframe className="admin-iframe" title="授课申请" src={`${getLeFEOrigin()}/#/app/admin/teacher_course_apply`} />
);
